import React, { useEffect, useState } from 'react'
import { PrivateAxios } from '../../environment/AxiosInstance'
import { SuccessMessage, WaringMessage } from '../../environment/ToastMessage'
import { UserAuth } from '../auth/Auth'

const templateActions = [
  { key: "tasktracker_ready_for_audit", label: "Task Tracker - Ready for Audit", default_gupshup: "83584594-5cb1-4dc8-a484-9d0c1e0411ff" },
  { key: "tasktracker_completed_1", label: "Task Tracker - Task Completed 1", default_gupshup: "8d4d5ddf-63b2-4c86-8ba3-159e9074457c" },
  { key: "tasktracker_completed_2", label: "Task Tracker - Task Completed 2", default_gupshup: "5f344b00-4305-4861-9060-b618d01655c7" },
  { key: "tasktracker_assigned", label: "Task Tracker - Task Assigned", default_gupshup: "3bd95861-ce59-493c-8cc4-6e8bc52335f2" },
  { key: "tasktracker_updated", label: "Task Tracker - Task Updated", default_gupshup: "562565ed-e003-4ec3-99fb-4e1754c8a54a" },
  { key: "tasktracker_switch_doer", label: "Task Tracker - Switch Doer", default_gupshup: "33ff688d-085e-4f2b-927b-55bf3a769877" },
  { key: "tasktracker_reopened", label: "Task Tracker - Task Reopened", default_gupshup: "64baa642-575f-4b30-baf3-d11bf5ea6aee" },
  { key: "tasktracker_audit_reopened", label: "Task Tracker - Audit Reopened", default_gupshup: "2082171d-523f-491f-9b89-ce7f5d12e24e" },
  { key: "tasktracker_delay", label: "Task Tracker - Task Delayed (Cron)", default_gupshup: "5a295ebf-a804-4f9f-b688-e419d24ce496" },
  { key: "tasktracker_remainder", label: "Task Tracker - Task Reminder (Cron)", default_gupshup: "98da2f92-c610-4e74-8c7c-802e2f54d438" },
  { key: "tasktracker_assigned_alternate", label: "Task Tracker - Task Assigned (Alternate)", default_gupshup: "22ab25a2-fea5-4048-a0d9-33eede9541d0" },

  { key: "checksheet_create", label: "Checksheet - Checksheet Created", default_gupshup: "0d58dab0-c46c-4e58-94cc-b96542b325cb" },
  { key: "checksheet_remainder", label: "Checksheet - Checksheet Reminder (Cron)", default_gupshup: "3a37f4e3-9657-401f-942c-b6e4d2aa0ec2" },
  { key: "checksheet_delay", label: "Checksheet - Checksheet Delayed (Cron)", default_gupshup: "832164c3-15d8-4366-8db3-e82872e54709" },
  { key: "checksheet_updated_1", label: "Checksheet - Checksheet Updated 1", default_gupshup: "25b30034-af3d-4306-ab65-aa2d7c485172" },
  { key: "checksheet_updated_2", label: "Checksheet - Checksheet Updated 2", default_gupshup: "7e3a5784-bdc6-4740-9882-f266bb0112df" },
  { key: "checksheet_completed", label: "Checksheet - Checksheet Completed", default_gupshup: "69a9e1e8-7e97-489b-82ca-256288e4a0e4" },
  { key: "checksheet_ready_for_audit", label: "Checksheet - Ready for Audit", default_gupshup: "76b7ab38-cd9c-4b7d-8814-5d1e16d31ef1" },
  { key: "checksheet_closed", label: "Checksheet - Checksheet Closed", default_gupshup: "7e5f2940-cd05-4638-bb60-ceb76e3c3103" },

  { key: "helpticket_raised", label: "Help Ticket - Ticket Raised", default_gupshup: "52d435bf-bf2a-41d1-bd6e-164c03f09e82" },
  { key: "helpticket_updated", label: "Help Ticket - Ticket Updated", default_gupshup: "b169223f-ea97-4ac9-ad43-d85c529c6322" },
  { key: "helpticket_cancelled", label: "Help Ticket - Ticket Cancelled", default_gupshup: "30960a71-de7e-483a-92fc-7c6353e395ed" },
  { key: "helpticket_switched", label: "Help Ticket - Ticket Switched", default_gupshup: "9a304279-c6c0-47eb-897e-40b1df7ff307" },
  { key: "helpticket_completed", label: "Help Ticket - Ticket Completed", default_gupshup: "2285e9f9-9430-46bf-8c7c-e4eaed56749d" },

  { key: "workflow_switch_doer", label: "Workflow - Switch Doer", default_gupshup: "a8293b29-3021-40c3-b4dd-027b33874584" }
];

function WhatsappSetting() {
  const [tab, setTab] = useState('')
  const { Logout, userDetails } = UserAuth();
  const [data, setData] = useState({
    type: tab,
    greenapi_instance_id: "",
    greenapi_apitoken_instance: "",
    maytapi_product_id: "",
    maytapi_phone_id: "",
    maytapi_api_token: "",
    meta_phone_id: "",
    meta_token: "",
    gupshup_phone: "",
    gupshup_token: "",
    templates: []
  })

  const getData = () => {
    PrivateAxios.get("get-whatsapp-setting")
      .then((res) => {

        setData({
          ...data,
          type: res.data.data.which_whatsapp,
          greenapi_instance_id: res.data.data.greenapi_instance_id,
          greenapi_apitoken_instance: res.data.data.greenapi_apitoken_instance,
          maytapi_product_id: res.data.data.maytapi_product_id,
          maytapi_phone_id: res.data.data.maytapi_phone_id,
          maytapi_api_token: res.data.data.maytapi_api_token,
          meta_phone_id: res.data.data.meta_phone_id,
          meta_token: res.data.data.meta_token,
          gupshup_phone: res.data.data.gupshup_phone,
          gupshup_token: res.data.data.gupshup_token,
          templates: res.data.data.templates || [],
        });
        setTab(res.data.data.which_whatsapp)
      }).catch((err) => {

      })
  }
  useEffect(() => {
    getData();
  }, [])

  const submit = (e) => {
    e.preventDefault();

    // Ensure on submit, we include default GupShup fields into data as an auto migration via the UI if not set
    let finalTemplates = [...(data.templates || [])];
    templateActions.forEach(actionObj => {
      const exists = finalTemplates.some(t => t.action === actionObj.key && (t.whatsapp_type?.toLowerCase() === tab?.toLowerCase() || !t.whatsapp_type));
      if (!exists && tab?.toLowerCase() === "gupshup" && actionObj.default_gupshup) {
        finalTemplates.push({ action: actionObj.key, whatsapp_type: "GupShup", template_id: actionObj.default_gupshup });
      }
    });

    const payload = { ...data, templates: finalTemplates };

    PrivateAxios.post("whatsapp-credential", payload)
      .then((res) => {
        SuccessMessage(res.data.msg)
      }).catch((err) => {
        if (err.response?.status == 401) {
          Logout();
        }
      })
  }

  const handleTemplateChange = (action, value) => {
    let updatedTemplates = [...(data.templates || [])];
    const existingIndex = updatedTemplates.findIndex(t => t.action === action && (t.whatsapp_type?.toLowerCase() === tab?.toLowerCase() || !t.whatsapp_type));

    if (existingIndex > -1) {
      updatedTemplates[existingIndex].template_id = value;
      updatedTemplates[existingIndex].whatsapp_type = tab;
    } else {
      updatedTemplates.push({ action: action, whatsapp_type: tab, template_id: value });
    }
    setData({ ...data, templates: updatedTemplates });
  }

  const getTemplateId = (actionObj) => {
    const tmpl = (data.templates || []).find(t => t.action === actionObj.key && (t.whatsapp_type?.toLowerCase() === tab?.toLowerCase() || !t.whatsapp_type));
    if (tmpl && tmpl.template_id) return tmpl.template_id;
    if (tab?.toLowerCase() === "gupshup" && actionObj.default_gupshup) {
      return actionObj.default_gupshup;
    }
    return "";
  }

  return (
    <div className="p-4">
      <form class="col-12" onSubmit={submit} id="users_details_section">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h6 class="fw-bold mb-0">Your WhatsApp</h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 col-sm-12 mb-12">
                    <label for="planned_date">Which One You Want To Used <span class="text-danger">*</span></label>
                    <select name="which_whatsapp" required class="form-select" onChange={(e) => { setTab(e.target.value); setData({ ...data, type: e.target.value }) }}>
                      <option value="greenapi" selected={tab == "greenapi"}>Green API</option>
                      <option value="Maytapi" selected={tab == "Maytapi"}>Maytapi</option>
                      <option value="Meta" selected={tab == "Meta"}>Meta</option>
                      <option value="GupShup" selected={tab == "GupShup"}>GupShup</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div className='col-12'>
            <div class="card">
              {tab?.toLowerCase() == "greenapi" ?
                <>
                  <div class="card-header">
                    <h6 class="fw-bold mb-0">WhatsApp Settings (Green Api)</h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12 col-sm-12 mb-12">
                        <div className='form-group'>
                          <label for="planned_date">IdInstance <span class="text-danger">*</span></label>
                          <input required type="text" name="greenapi_instance_id" value={data.greenapi_instance_id ? data.greenapi_instance_id : ""} class="form-control" onChange={(e) => setData({ ...data, greenapi_instance_id: e.target.value })} />
                        </div>
                      </div>
                      <div class="col-md-12 col-sm-12 mb-12">
                        <div className='form-group mb-0'>
                          <label for="planned_date">ApiTokenInstance <span class="text-danger">*</span></label>
                          <input type="text" required name="greenapi_apitoken_instance" value={data.greenapi_apitoken_instance ? data.greenapi_apitoken_instance : ""} class="form-control" onChange={(e) => setData({ ...data, greenapi_apitoken_instance: e.target.value })} />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
                : tab?.toLowerCase() == "gupshup" ?
                  <>
                    <div class="card-header">
                      <h6 class="fw-bold mb-0">WhatsApp Settings (GupShup)</h6>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12 col-sm-12 mb-12">
                          <div className='form-group'>
                            <label for="planned_date">Token<span class="text-danger">*</span></label>
                            <input type="text" name="gupshup_token" class="form-control" value={data.gupshup_token ? data.gupshup_token : ""} required="required" onChange={(e) => setData({ ...data, gupshup_token: e.target.value })} />
                          </div>
                          {/* userDetails.position == "Owner" ? data.gupshup_token : "**********************" + data.gupshup_token.slice(-5)  */}
                        </div>
                        <div class="col-md-12 col-sm-12 mb-12">
                          <div className='form-group'>
                            <label for="planned_date">Phone Number <span class="text-danger">*</span></label>
                            <input type="text" name="gupshup_phone" value={data.gupshup_phone ? data.gupshup_phone : ""} class="form-control" required="required" onChange={(e) => setData({ ...data, gupshup_phone: e.target.value })} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </> :
                  tab?.toLowerCase() == "maytapi" ?
                    <>
                      <div class="card-header">
                        <h6 class="fw-bold mb-0">WhatsApp Settings (Maytapi)</h6>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12 col-sm-12 mb-12">
                            <div className='form-group'>
                              <label for="planned_date">PRODUCT ID <span class="text-danger">*</span></label>
                              <input type="text" name="maytapi_product_id" value={data.maytapi_product_id ? data.maytapi_product_id : ""} class="form-control" required="required" onChange={(e) => setData({ ...data, maytapi_product_id: e.target.value })} />
                            </div>

                          </div>
                          <div class="col-md-12 col-sm-12 mb-12">
                            <div className='form-group'>
                              <label for="planned_date">PHONE ID <span class="text-danger">*</span></label>
                              <input type="text" name="maytapi_phone_id" value={data.maytapi_phone_id ? data.maytapi_phone_id : ""} class="form-control" required="required" onChange={(e) => setData({ ...data, maytapi_phone_id: e.target.value })} />
                            </div>
                          </div>
                          <div class="col-md-12 col-sm-12 mb-12">
                            <div className='form-group mb-0'>
                              <label for="planned_date">API TOKEN <span class="text-danger">*</span></label>
                              <input type="text" name="maytapi_api_token" value={data.maytapi_api_token ? data.maytapi_api_token : ""} class="form-control" required="required" onChange={(e) => setData({ ...data, maytapi_api_token: e.target.value })} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </> :
                    tab?.toLowerCase() == "meta" ?
                      <>
                        <div class="card-header">
                          <h6 class="fw-bold mb-0">WhatsApp Settings (Meta)</h6>
                        </div>
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-12 col-sm-12 mb-12">
                              <div className='form-group'>
                                <label for="planned_date">PHONE ID <span class="text-danger">*</span></label>
                                <input type="text" name="meta_phone_id" value={data.meta_phone_id ? data.meta_phone_id : ""} class="form-control" required="required" onChange={(e) => setData({ ...data, meta_phone_id: e.target.value })} />
                              </div>
                            </div>
                            <div class="col-md-12 col-sm-12 mb-12">
                              <div className='form-group mb-0'>
                                <label for="planned_date">API TOKEN <span class="text-danger">*</span></label>
                                <input type="text" name="meta_token" value={data.meta_token ? data.meta_token : ""} class="form-control" required="required" onChange={(e) => setData({ ...data, meta_token: e.target.value })} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </> : ""
              }

              <div class="card-header mt-4">
                <h6 class="fw-bold mb-0">Dynamic Template IDs</h6>
              </div>
              <div class="card-body">
                <div class="row">
                  {templateActions.map((item, index) => (
                    <div class="col-md-6 col-sm-12 mb-3" key={index}>
                      <div className="form-group mb-0">
                        <label>{item.label}</label>
                        <input
                          type="text"
                          value={getTemplateId(item)}
                          onChange={(e) => handleTemplateChange(item.key, e.target.value)}
                          class="form-control"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* {userDetails.position == "Owner" ? */}
              <div class="card-footer text-end">
                <button type="submit" name="submit_button" class="btn btn-exp-green ms-auto">Update</button>
              </div>
              {/* : ""
              } */}
            </div>
          </div>
        </div>
        {/* <div class="row">
          <div class="col-12">
            <div class="card card-info card-outline card-outline-tabs">
              <div class="card-header p-0 border-bottom-0">
                <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="custom-tabs-four-home-tab" data-bs-toggle="pill" href="#custom-tabs-four-home" role="tab" aria-controls="custom-tabs-four-home" aria-selected="true">{tab == "greenapi" ? "GREEN API" : "Maytapi"}</a>
                  </li>

                </ul>
              </div>
              <div class="card-body">
                <div class="tab-content" id="custom-tabs-four-tabContent">
                  <div class="tab-pane fade active show" id="custom-tabs-four-home" role="tabpanel" aria-labelledby="custom-tabs-four-home-tab">
                    <div class="row">
                      <div class="col-12">
                        {tab == "greenapi" ?
                          <div class="card">
                            <div class="card-header">
                              <h3 class="card-title">WHATSAPP SETTINGS (GREENAPI)</h3>
                            </div>
                            <form >
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-12 col-sm-12 mb-12">
                                    <label for="planned_date">IdInstance <span class="text-danger">*</span></label>
                                    <input type="text" name="greenapi_instance_id" value={data.greenapi_instance_id} class="form-control" onChange={(e) => setData({ ...data, greenapi_instance_id: e.target.value })} />

                                  </div>
                                  <div class="col-md-12 col-sm-12 mb-12">
                                    <label for="planned_date">ApiTokenInstance <span class="text-danger">*</span></label>
                                    <input type="text" name="greenapi_apitoken_instance" value={data.greenapi_apitoken_instance} class="form-control" onChange={(e) => setData({ ...data, greenapi_apitoken_instance: e.target.value })} />

                                  </div>
                                </div>
                              </div>
                              <div class="card-footer">
                                <div class="col-md-4 col-sm-12 mb-4">
                                  <button type="submit" name="submit_button" class="btn btn-md btn-primary float-start me-2">Update</button>
                                </div>
                                <div class="col-md-8 col-sm-12 mb-8"></div>
                              </div>
                            </form>
                          </div>
                          :
                          <div class="card">
                            <div class="card-header">
                              <h3 class="card-title">WHATSAPP SETTINGS (Maytapi)</h3>
                            </div>
                            <form >
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-12 col-sm-12 mb-12">
                                    <label for="planned_date">PRODUCT ID <span class="text-danger">*</span></label>
                                    <input type="text" name="maytapi_product_id" value={data.maytapi_product_id} class="form-control" required="required" onChange={(e) => setData({ ...data, maytapi_product_id: e.target.value })} />
                                  </div>
                                  <div class="col-md-12 col-sm-12 mb-12">
                                    <label for="planned_date">PHONE ID <span class="text-danger">*</span></label>
                                    <input type="text" name="maytapi_phone_id" value={data.maytapi_phone_id} class="form-control" required="required" onChange={(e) => setData({ ...data, maytapi_phone_id: e.target.value })} />
                                  </div>
                                  <div class="col-md-12 col-sm-12 mb-12">
                                    <label for="planned_date">API TOKEN <span class="text-danger">*</span></label>
                                    <input type="text" name="maytapi_api_token" value={data.maytapi_api_token} class="form-control" required="required" onChange={(e) => setData({ ...data, maytapi_api_token: e.target.value })} />

                                  </div>
                                </div>
                              </div>
                              <div class="card-footer">
                                <div class="col-md-4 col-sm-12 mb-4">
                                  <button type="submit" name="submit_button" class="btn btn-md btn-primary float-start me-2" onClick={submit}>Update</button>
                                </div>
                                <div class="col-md-8 col-sm-12 mb-8"></div>
                              </div>
                            </form>
                          </div>
                        }

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div > */}

      </form>
    </div >
  )
}

export default WhatsappSetting